module.exports = __webpack_public_path__ + "fonts/lmTPyozk.woff2";